export var TranslationDirectionType;
(function (TranslationDirectionType) {
    TranslationDirectionType[TranslationDirectionType["Horizontal"] = 0] = "Horizontal";
    TranslationDirectionType[TranslationDirectionType["Vertical"] = 1] = "Vertical";
})(TranslationDirectionType || (TranslationDirectionType = {}));
